module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_05.jpg?v=ed1af35a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_05.jpg
 ** module id = 62
 ** module chunks = 1 2
 **/